import { api } from './api';
import { AuditLogPage, AuditLogFilters } from '../types/Audit';

/**
 * Fetch a cursor-paginated page of admin audit logs.
 */
export const getAuditLogs = (filters: AuditLogFilters = {}): Promise<AuditLogPage> => {
  const params: Record<string, string | number | boolean> = {};
  if (filters.search) params.search = filters.search;
  if (filters.entity) params.entity = filters.entity;
  if (filters.action) params.action = filters.action;
  if (filters.actorId !== undefined) params.actorId = filters.actorId;
  if (filters.success !== undefined) params.success = filters.success;
  if (filters.from) params.from = filters.from;
  if (filters.to) params.to = filters.to;
  if (filters.cursor !== undefined) params.cursor = filters.cursor;
  if (filters.limit !== undefined) params.limit = filters.limit;

  return api.get('/admin/audit-logs', { params }).then((r) => r.data);
};
